import React from 'react';
import { connect } from 'react-redux';
import FSObjectUploadStatusList from 'components/event/FileSystem/FSObjectUploadStatusList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import _ from 'underscore';
import styled from 'styled-components';

import { toggleEventUploadStatus } from 'actions/Event';

const Pane = styled.div`
  position: fixed;
  width: 384px;
  bottom: 0;
  overflow: hidden;
  margin-left: 35%;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #333;
`;

const PaneHeader = styled.div`
  padding: 16px;
  position: relative;
  color: #fff;
  background-color: #333;
  height: 48px;
`;

const PaneCloseButton = styled.span`
  float: right;
  cursor: pointer;
`;

const EventDashUploadStatusPane = ({
  visible,
  statuses,
  toggleEventUploadStatus
}) => {
  if (!visible) return null;

  return (
    <Pane>
      <PaneHeader>
        Uploading {_.size(statuses)} files
        <PaneCloseButton onClick={toggleEventUploadStatus}>
          <FontAwesomeIcon icon={faTimes} />
        </PaneCloseButton>
      </PaneHeader>
      <FSObjectUploadStatusList statuses={statuses} />
    </Pane>
  );
};

export default connect(
  state => {
    const { eventUploadStatusVisibility, eventFSObjectUploadStatuses } = state;

    return {
      statuses: eventFSObjectUploadStatuses,
      visible: eventUploadStatusVisibility
    };
  },
  {
    toggleEventUploadStatus
  }
)(EventDashUploadStatusPane);
